import { useState } from 'react';
import * as reactUse from 'react-use';

const { useDebounce } = reactUse;

/**
 * A hook that returns a debounced version of a value.
 *
 * @param value The value to debounce
 * @param delay The delay in milliseconds before the value updates
 * @returns The debounced value
 *
 * @example
 * ```tsx
 * const [searchQuery, setSearchQuery] = useState('');
 * const debouncedQuery = useDebouncedValue(searchQuery, 300);
 * ```
 */
export function useDebouncedValue<T>(value: T, delay: number = 300): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useDebounce(() => setDebouncedValue(value), delay, [value]);

  return debouncedValue;
}
